<template>
  <v-data-table
    style="cursor: pointer"
    :items="items"
    :headers="headers"
    :items-per-page="-1"
    :mobile-breakpoint="dataTableMobileBreakpoint"
    group-by="tank.vesselName"
    @click:row="handleRowClick"
  >
    <template v-slot:group.header="props">
      <td
        class="text-start pa-2 font-weight-medium"
        :colspan="props.headers.length"
      >
        <v-tooltip bottom color="black">
          <template v-slot:activator="{ on, attrs }">
            <span v-on="on" v-bind="attrs">
              <v-icon left>mdi-ferry</v-icon>
              {{ props.group }}
            </span>
          </template>
          Vessel: {{ props.group }}
        </v-tooltip>
      </td>
    </template>
    <template v-slot:item.openingStatus.quantityOnBoard="{ item }">
      <span v-if="item.openingStatus">{{
        `${item.openingStatus.quantityOnBoard} ${item.tank.qtyUom}`
      }}</span>
    </template>
    <template v-slot:item.closingStatus.quantityOnBoard="{ item }">
      <span v-if="item.closingStatus">{{
        `${item.closingStatus.quantityOnBoard} ${item.tank.qtyUom}`
      }}</span>
    </template>
    <template v-slot:item.openingStatus.statusDateTimeLt="{ item }">
      <span v-if="item.openingStatus">{{
        item.openingStatus.statusDateTimeLt | removeTAndSecondsAndFormatDate
      }}</span>
      <span v-else>No Status Found</span>
    </template>
    <template v-slot:item.closingStatus.statusDateTimeLt="{ item }">
      <span v-if="item.closingStatus">{{
        item.closingStatus.statusDateTimeLt | removeTAndSecondsAndFormatDate
      }}</span>
      <span v-else>No Status Found</span>
    </template>
    <template v-slot:item.openingStatus.fillPercent="{ item }">
      <table-percentage-bar
        v-if="item.openingStatus"
        :value="item.openingStatus.fillPercent"
        :color="getProgressColourByFillPercent(item.openingStatus.fillPercent)"
      />
    </template>
    <template v-slot:item.closingStatus.fillPercent="{ item }">
      <table-percentage-bar
        v-if="item.closingStatus"
        :value="item.closingStatus.fillPercent"
        :color="getProgressColourByFillPercent(item.closingStatus.fillPercent)"
      />
    </template>
  </v-data-table>
</template>

<script>
import ResponsiveSizeHelperMixin from '../../mixins/ResponsiveSizeHelperMixin';
import TankStatusMixin from '../../mixins/TankStatusMixin';
import TablePercentageBar from '../ui/TablePercentageBar.vue';

export default {
  components: { TablePercentageBar },
  name: 'DailyTankReportOpenAndCloseTable',
  mixins: [TankStatusMixin, ResponsiveSizeHelperMixin],
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        { text: 'Tank', value: 'tank.tankName' },
        { text: 'Opening Status Date (Lt)', value: 'openingStatus.statusDateTimeLt' },
        { text: 'Opening Bulk', value: 'openingStatus.bulk' },
        { text: 'Opening Quantity', value: 'openingStatus.quantityOnBoard' },
        { text: 'Opening Fill Level', value: 'openingStatus.fillPercent' },
        { text: 'Closing Status Date (Lt)', value: 'closingStatus.statusDateTimeLt' },
        { text: 'Closing Bulk', value: 'closingStatus.bulk' },
        { text: 'Closing Quantity', value: 'closingStatus.quantityOnBoard' },
        { text: 'Closing Fill Level', value: 'closingStatus.fillPercent' },
      ],
    };
  },
  methods: {
    handleRowClick(item) {
      if (item.tank) {
        this.goToTankDetails(item.tank);
      }
    },
  },
};
</script>
